export default __webpack_public_path__ + "static/media/x1-2.64f76289.mp3";